import Vue from 'vue';
import VueRouter from 'vue-router';

// Dashboard Components
import Dashboard from '../views/homepage';
import ManageAuction from '../views/auction-manage';
import ManageUser from '../views/users/manage';
import AuctionsList from '../views/auctions/list';
import AuctionsAdd from '../views/auctions/add';
import LiveAuction from '../views/auction-live';
import Login from '../views/login';

import UsersVerification from '../views/users/verifications';
import UsersList from '../views/users/list';
import StatisticsLive from '../views/statistics/live';

// Sample Pages
import error404 from '../views/sample-pages/error-404.vue';
import error500 from '../views/sample-pages/error-500.vue';

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/',
            component: Dashboard
        },
        {
            path: '/auctions',
            component: AuctionsList
        },
        {
            path: '/auctions/add',
            component: AuctionsAdd
        },
        {
            path: '/auctions/manage/:id',
            component: ManageAuction
        },
        {
            path: '/auctions/live/:id',
            component: LiveAuction
        },
        {
            path: '/users',
            component: UsersList
        },
        {
            path: '/users/verifications',
            component: UsersVerification
        },
        {
            path: '/users/manage/:id',
            component: ManageUser
        },
        {
            path: '/statistics/live',
            component: StatisticsLive
        },
        {
            path: '/500',
            component: error500
        },
        {
            path: '*',
            component: error404
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: 'history',
    linkActiveClass: 'active'
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/index.ts